export const GET_PAYMENT_DETAILS = '@business/GET_PAYMENT_DETAILS';
export const SET_PAYMENT_DETAILS = '@business/SET_PAYMENT_DETAILS';
